<template>
  <div class="tc-container">
    <ul>
      <li :class="actvIndex == 1 ? 'is-active' : ''" @click="handSelect(1)">
        日
      </li>
      <li :class="actvIndex == 2 ? 'is-active' : ''" @click="handSelect(2)">
        月
      </li>
      <li :class="actvIndex == 3 ? 'is-active' : ''" @click="handSelect(3)">
        年
      </li>
    </ul>
    <div class="tp-chart" ref="myChart"></div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {
        actvIndex: 1,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let xLabel = ['18', '19', '20', '21', '22', '23', '24']
        let goOutSchool = ['20', '7', '18', '4', '19', '8', '6']

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                color: '#57617B',
              },
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              axisLine: {
                lineStyle: {
                  color: '#808487',
                },
              },
              axisLabel: {
                textStyle: {
                  color: '#E6E6E6',
                  fontSize: 12,
                },
              },
              data: xLabel,
            },
          ],
          yAxis: [
            {
              type: 'value',
              min: 0,
              max: 20,
              splitNumber: 7,
              axisTick: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: '#57617B',
                },
              },
              axisLabel: {
                margin: 10,
                textStyle: {
                  color: '#fff',
                  fontSize: 12,
                },
              },
              splitLine: {
                lineStyle: {
                  color: '#4D5054',
                },
              },
            },
          ],
          series: [
            {
              name: '',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 2,
                },
              },
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: '#25A6A1',
                      },
                      {
                        offset: 1,
                        color: '#0C2E2D',
                      },
                    ],
                    false
                  ),
                  shadowColor: 'rgba(0, 0, 0, 0.1)',
                  shadowBlur: 10,
                },
              },
              itemStyle: {
                normal: {
                  color: '#53E8F1',
                },
                emphasis: {
                  color: 'rgb(0,196,132)',
                  borderColor: 'rgba(0,196,132,0.2)',
                  extraCssText: 'box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);',
                  borderWidth: 10,
                },
              },
              data: goOutSchool,
            },
          ],
        }
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      color: #15a983;
      cursor: pointer;
      li {
        margin-right: 30px;
      }
      .is-active {
        border-bottom: 1px solid #ffc600;
        padding-bottom: 7px;
        position: relative;
        color: #fff;
        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: 5px solid #ffc600;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          bottom: 0px;
          left: 3px;
        }
      }
    }
    .tp-chart {
      margin-top: 20px;
      width: 100%;
      height: 7.6vw;
    }
  }
</style>
